const ERROR_MESSAGE = 'Invalid input, please provide inches in the format: 80 or 80-1/16.'

const QUOTES_EMAIL = "quotes@woodportdoors.com"

export function parseInchesToDecimal(inputString: string) {
    const regex = /^(\d+)(?:-(\d+)\/(\d+))?$/
    const match = inputString.match(regex)

    if (!match) {
        throw new Error(ERROR_MESSAGE)
    }

    const wholeInches = parseInt(match[1])
    const numerator = parseInt(match[2])
    const denominator = parseInt(match[3])

    let fractionalInches = 0
    if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
        if (denominator > 16) {
            throw new Error('Denominator must be equal to or less than 16')
        }
        fractionalInches = numerator / denominator
    }

    if (isNaN(wholeInches) || isNaN(fractionalInches)) {
        throw new Error(ERROR_MESSAGE)
    }

    // Calculate the total inches as a decimal
    const totalInches = wholeInches + fractionalInches

    return totalInches
}

export function validateHeight(height: number, productName: string = "Door" as string) {
    if (height < 60 || height > 96) {
        const subject = `Quote Request: ${height}" Tall ${productName}`
        const quoteText = `<a href='mailto:${QUOTES_EMAIL}?subject=${subject}'>${QUOTES_EMAIL}</a>`
        throw new Error(`Heights outside 60 to 96 inches must be sent to ${quoteText}.`)
    }
}

export function validateWidth(width: number, productName: string = "Door" as string) {
    if (width < 12 || width > 48) {
        const subject = `Quote Request: ${width}" Wide ${productName}`
        const quoteText = `<a href='mailto:${QUOTES_EMAIL}?subject=${subject}'>${QUOTES_EMAIL}</a>`
        throw new Error(`Widths outside 12 to 48 inches must be sent to ${quoteText}.`)
    }
}

